var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"shipment-doc-revamp oms-compact-page oms-list-page shipment-docs-page",attrs:{"fluid":""}},[(_vm.showScreen)?_c('shipmentDocList'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }